var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.267 16.07h2.175c.624 0 1.03-.349 1.03-.916 0-.558-.406-.927-1.03-.927h-2.307l-1.617-1.758-.17 2.477.7.7c.34.33.652.425 1.22.425zM9.945 27c.322 0 .605-.142.785-.36l2.96-3.526c.302-.359.34-.444.463-.803.094-.274.16-.53.226-.794l-1.654-2.052-.492 2.364-2.78 3.29c-.264.302-.453.548-.453.945 0 .558.407.936.945.936z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88 27c.491 0 .955-.369.955-1.021 0-.246-.076-.473-.208-.738L17.679 21.3a6.8 6.8 0 0 0-.558-.936l-1.238-1.758.085-.256c.34-1.04.472-1.682.548-2.703l.199-2.903c.094-1.38-.7-2.515-2.128-2.515-1.077 0-1.786.605-2.77 1.56l-1.522 1.503c-.52.52-.68.936-.728 1.58l-.189 2.372c-.047.624.303 1.03.86 1.069.53.037.927-.284.984-.946l.217-2.619.898-.794c.17-.151.407-.075.388.17l-.17 2.345c-.076 1.116.397 1.929.945 2.619l1.976 2.496c.208.246.227.34.312.51l2.108 4.255c.246.491.605.652.984.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.713 9.434c1.229 0 2.221-1.021 2.221-2.203A2.221 2.221 0 0 0 15.712 5c-1.228 0-2.202.993-2.202 2.231 0 1.182.974 2.203 2.203 2.203z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/Walking.acfd7b2c073538b5b7ef63ddc4d0cd8e.svg";
export { ForwardRef as ReactComponent };